import { api, PartipostApiResponse } from './'

import { ResetPasswordRequestPayload, UpdatePasswordRequestPayload, BasicSignUpResetPayload } from '../../state/profile'
import { STATE_KEYS } from 'state/requests'

export interface LoginRequest {
    email: string
    password: string
    redirectLink?: string | null
}
interface TeamResponseState {
    uuid: string
    name: string
}
interface PermissionState {
    uuid: string
    code: string
    constraints: string[]
}
export interface RoleResponseState {
    uuid: string
    name: string
    permissions: PermissionState[]
}
export interface LoginResponse {
    key: string
    is_registered: boolean
    member_uuid: string
}

export const login = (payload: LoginRequest) => api.post<PartipostApiResponse<LoginResponse>>('auth/login/', payload)

export interface LogoutResponse {
    detail: string
}

export const logout = () => api.post<PartipostApiResponse<LogoutResponse>>('auth/logout/')

export const resetPassword = (payload: ResetPasswordRequestPayload) =>
    api.post<PartipostApiResponse<any>>('auth/password/reset/', payload)

export const updatePassword = (payload: UpdatePasswordRequestPayload) =>
    api.post<PartipostApiResponse<any>>('auth/password/reset/confirm/', payload)

export const verifyToken = (payload: BasicSignUpResetPayload) =>
    api.post<PartipostApiResponse<PartipostApiResponse<{ email: string }>>>(
        'auth/password/reset/validate-token/',
        payload,
    )

export interface ProfileRequest {
    stateKey?: STATE_KEYS
    onSuccess?: (response?: ProfileResponse) => void
}

export interface ProfileResponse {
    starred: boolean
    email: string
    name: string
    is_admin_user: boolean
    is_internal_staff: boolean
    is_registered: boolean
    teams: TeamResponseState[]
    role: RoleResponseState
    uuid: string
    is_campaigns_empty: boolean
}

export const getProfile = () => api.get<PartipostApiResponse<ProfileResponse>>('profile/detail/')
